// extracted by mini-css-extract-plugin
export default {"InputWrap":"index_InputWrap__b2au0","Input":"index_Input__N7Kk3"};